import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { View } from 'react-native';
import { Card, getTestId, isValidObject } from '@airtel/air-design-system';
import { TypographyWidget } from '../typography-widget';
import FormField from './components/form-field/FormField';
import { CalloutWidget } from '../callout-widget';
export var MyWifiFormWidgetComponent = props => {
  var _a;
  var _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'MyWifiFormWidget' : _props$testID,
    style = props.style,
    calloutProps = props.calloutProps,
    onUserAction = props.onUserAction,
    headingProps = props.headingProps,
    _formFields = props.formFields,
    onFormValidatationSuccessMetaData = props.onFormValidatationSuccessMetaData,
    onFormValidatationFailureMetaData = props.onFormValidatationFailureMetaData,
    formContainerStyle = props.formContainerStyle,
    cardProps = props.cardProps;
  var _useState = useState(_formFields),
    formFields = _useState[0],
    setFormFields = _useState[1];
  useEffect(() => {
    setFormFields(_formFields);
  }, [_formFields]);
  var validateInputText = (key, value) => {
    var _a, _b;
    var formField = formFields[key];
    formField.value = value;
    formField.isValid = (_a = formField === null || formField === void 0 ? void 0 : formField.validationRules) === null || _a === void 0 ? void 0 : _a.reduce((prev, currentRule) => {
      var regexes = currentRule.regexes;
      if ((regexes === null || regexes === void 0 ? void 0 : regexes.length) > 0) {
        var isRegexValidated = regexes === null || regexes === void 0 ? void 0 : regexes.reduce((prevValue, currentRegex) => {
          var _a;
          var isRegexValidated = (_a = new RegExp(currentRegex)) === null || _a === void 0 ? void 0 : _a.test(value);
          return isRegexValidated && prevValue;
        }, true);
        currentRule.isValid = isRegexValidated;
        return prev && isRegexValidated;
      }
      return prev;
    }, true);
    var isAllRulesValidated = (_b = Object.keys(formFields)) === null || _b === void 0 ? void 0 : _b.reduce((prev, currentKey) => {
      var currentField = formFields[currentKey];
      var _currentField$validat = currentField.validationRules,
        validationRules = _currentField$validat === void 0 ? [] : _currentField$validat,
        _currentField$value = currentField.value,
        value = _currentField$value === void 0 ? '' : _currentField$value;
      if ((validationRules === null || validationRules === void 0 ? void 0 : validationRules.length) === 0) return prev;
      var isCurrentRuleValidated = validationRules === null || validationRules === void 0 ? void 0 : validationRules.reduce((prevRuleValue, currentRule) => {
        var regexes = currentRule.regexes;
        if ((regexes === null || regexes === void 0 ? void 0 : regexes.length) > 0) {
          var isCurrentRegexValidated = regexes === null || regexes === void 0 ? void 0 : regexes.reduce((prevValue, currentRegex) => {
            var isRegexValidated = new RegExp(currentRegex).test(value);
            return isRegexValidated && prevValue;
          }, true);
          return prevRuleValue && isCurrentRegexValidated;
        }
        return true;
      }, true);
      return prev && isCurrentRuleValidated;
    }, true);
    setFormFields(Object.assign(Object.assign({}, formFields), {
      [key]: formField
    }));
    if (isAllRulesValidated) {
      onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(onFormValidatationSuccessMetaData, formFields);
    } else {
      onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(onFormValidatationFailureMetaData, formFields);
    }
  };
  var onAppendItemPressHandler = key => {
    var formField = formFields[key];
    var inputFieldProps = formField === null || formField === void 0 ? void 0 : formField.inputFieldProps;
    if (inputFieldProps === null || inputFieldProps === void 0 ? void 0 : inputFieldProps.shouldToggleInputFieldStateOnAppendItemPress) {
      if ((inputFieldProps === null || inputFieldProps === void 0 ? void 0 : inputFieldProps.inputFieldState) === 'primary') {
        inputFieldProps.inputFieldState = 'secondary';
      } else {
        inputFieldProps.inputFieldState = 'primary';
      }
    }
    onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(inputFieldProps === null || inputFieldProps === void 0 ? void 0 : inputFieldProps.onAppendItemPress, Object.assign({}, formField));
    setFormFields(Object.assign(Object.assign({}, formFields), {
      [key]: formField
    }));
  };
  return _jsxs(Card, Object.assign({}, cardProps, getTestId(testID), {
    style: [style]
  }, {
    children: [!!isValidObject(headingProps) && _jsx(TypographyWidget, Object.assign({}, headingProps)), !!((_a = Object.keys(formFields)) === null || _a === void 0 ? void 0 : _a.length) && _jsx(View, Object.assign({
      style: [formContainerStyle]
    }, {
      children: Object.keys(formFields).sort((key1, key2) => {
        var _a, _b;
        return ((_a = formFields[key1]) === null || _a === void 0 ? void 0 : _a.renderIndex) - ((_b = formFields[key2]) === null || _b === void 0 ? void 0 : _b.renderIndex);
      }).map((key, index) => {
        var field = formFields === null || formFields === void 0 ? void 0 : formFields[key];
        return _jsx(FormField, {
          fieldName: key,
          index: index,
          field: field,
          onAppendItemPressHandler: onAppendItemPressHandler,
          onUserAction: onUserAction,
          validateInputText: validateInputText
        }, key);
      })
    })), isValidObject(calloutProps) && _jsx(CalloutWidget, Object.assign({}, calloutProps))]
  }));
};
MyWifiFormWidgetComponent.genericRendererKey = 'AirMyWifiFormWidget';